import { USER_ROLES, type UserRole } from '../types/user';

export const ROLE_LABELS: Record<UserRole, string> = {
  [USER_ROLES.ADMIN]: 'Admin',
  [USER_ROLES.DEVELOPER]: 'Developer',
  [USER_ROLES.CLIENT]: 'Client',
  [USER_ROLES.AFFILIATE]: 'Marketing Affiliate',
};

export function getRoleLabel(role: UserRole | null | undefined): string {
  return role ? ROLE_LABELS[role] || role : 'Account';
}
